module.exports = __webpack_public_path__ + "img/new-Instagram-logo.a10a1e2e.svg";